import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Chip,
} from '@mui/material';
import { motion } from 'framer-motion';

const projects = [
  {
    title: 'E-commerce Platform',
    description:
      'A full-stack e-commerce platform built with React, Node.js, and MongoDB. Features include user authentication, product management, and payment integration.',
    image: 'https://source.unsplash.com/random/800x600?ecommerce',
    technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    demoLink: '#',
    githubLink: '#',
  },
  {
    title: 'Task Management App',
    description:
      'A collaborative task management application with real-time updates, team collaboration features, and progress tracking.',
    image: 'https://source.unsplash.com/random/800x600?task',
    technologies: ['React', 'Firebase', 'Material-UI'],
    demoLink: '#',
    githubLink: '#',
  },
  {
    title: 'AI Image Generator',
    description:
      'An AI-powered image generation tool that creates unique artwork based on text descriptions using machine learning models.',
    image: 'https://source.unsplash.com/random/800x600?ai',
    technologies: ['Python', 'TensorFlow', 'React', 'FastAPI'],
    demoLink: '#',
    githubLink: '#',
  },
];

const Projects: React.FC = () => {
  return (
    <Box sx={{ py: 8, minHeight: '100vh' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" component="h1" gutterBottom>
            My Projects
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Here are some of the projects I've worked on. Each project is unique and
            showcases different aspects of my skills and experience.
          </Typography>

          <Grid container spacing={4} sx={{ mt: 4 }}>
            {projects.map((project, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'rgba(255, 255, 255, 0.05)',
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={project.image}
                    alt={project.title}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {project.title}
                    </Typography>
                    <Typography paragraph color="text.secondary">
                      {project.description}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {project.technologies.map((tech) => (
                        <Chip
                          key={tech}
                          label={tech}
                          size="small"
                          sx={{ bgcolor: 'primary.main' }}
                        />
                      ))}
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button size="small" href={project.demoLink} target="_blank">
                      Live Demo
                    </Button>
                    <Button size="small" href={project.githubLink} target="_blank">
                      GitHub
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Projects; 